import { model } from "core/util";
import { PensionDssContract, PensionDssContractDto } from "types";

import { PensionDssContractDetail } from "./PensionDssContractDetail";

export const PensionDss = model.createModel<PensionDssContractDto, PensionDssContract>((json) => ({
    idObject: json.idObject,
    contractDetail: PensionDssContractDetail.fromServer(json.contractDetail),
}));
